import React from 'react';
import EllipsisLightMode from '../../images/ellipsis.svg';
import EllipsisDarkMode from '../../images/ellipsis_light.svg';
import ShareLightMode from '../../images/share.svg';
import ShareDarkMode from '../../images/share_light.svg';

const HelpPage = () => (
	<section>
		<div className="wrapper">
			<h2 style={{ textAlign: 'center' }}>Add the app to your phone <span style={{ whiteSpace: "nowrap" }}>or tablet</span></h2>

			<h3>Safari for Apple iOS</h3>

			<p>Use Safari with an Apple iOS device to add the app&rsquo;s icon to your home screen. This will give you easy access to Unbridled Prayers.</p>

			<ol>
				<li>Open the Safari app.</li>
				<li>Open <strong>UnbridledPrayers.app</strong>.</li>
				<li>Click the Share Menu icon (
					<img className="light-theme" src={ShareLightMode} style={{ width: "17px", padding: "0 2px", transform: "translateY(2.5px)", display: "inline-block" }} alt="share icon" />
					<img className="dark-theme" src={ShareDarkMode} style={{ width: "17px", padding: "0 2px", transform: "translateY(2.5px)", display: "inline-block" }} alt="share icon" />
				).</li>
				<li>Select &ldquo;Add to Home Screen&rdquo; and follow the instructions given.</li>
			</ol>

			<h3>Google Chrome for Android</h3>

			<p>Use Google Chrome with an Android device. When you visit <strong>UnbridledPrayers.app</strong> on a phone or tablet for the first time, you should be prompted to add it to your home screen. Click the prompt to add the app&rsquo;s icon. This will give you easy access to Unbridled Prayers.</p>

			<p>If you do not get this prompt using Chrome, follow these instructions. Note: These instructions will only work on Android. For an iOS device, please use the Safari instructions above.</p>

			<ol>
				<li>Open the Chrome app.</li>
				<li>Open <strong>UnbridledPrayers.app</strong>.</li>
				<li>Tap the menu icon (
					<img className="light-theme" src={EllipsisLightMode} style={{ height: "15px", padding: "0 3px", transform: "translateY(2.5px)", display: "inline-block" }} alt="menu icon" />
					<img className="dark-theme" src={EllipsisDarkMode} style={{ height: "15px", padding: "0 3px", transform: "translateY(2.5px)", display: "inline-block" }} alt="menu icon" />
				) and tap &ldquo;Install app.&rdquo;</li>
			</ol>
		</div>
	</section>
);

export default HelpPage;